import { Vue, Component } from 'vue-property-decorator'
import ShipmentsSidebar from '@/modules/shipments-module/components/sidebar/shipments-sidebar.vue'
import { shipmentsStore } from '@/modules/shipments-module/store/shipments.store'

@Component({
    components: {
        ShipmentsSidebar
    }
})
export default class ShipmentsModule extends Vue {
    beforeCreate(): void {
        shipmentsStore.register()
    }
    beforeDestroy(): void {
        shipmentsStore.unregister()
    }
}
